import { AufnahmebogenBerater } from './AufnahmebogenBerater';
import { AufnahmebogenBwl } from './AufnahmebogenBwl';
import { AufnahmebogenKraftstoffe } from './AufnahmebogenKraftstoffe';
import { AufnahmebogenStrom } from './AufnahmebogenStrom';
import { AufnahmebogenWaerme } from './AufnahmebogenWaerme';
import { AufnahmebogenWasser } from './AufnahmebogenWasser';
import { Import } from './Import';
import { ImportConstants } from '../ImportConstants';

export class ImportAufnahmebogen extends Import {

    protected dataDb: any = {};
    protected dataSheet: any = {};
    protected objBerater: any;
    protected objBwl: any;
    protected objKraftstoffe: any;
    protected objStrom: any;
    protected objWaerme: any;
    protected objWasser: any;
    public version: Readonly<number | string> = null;

    constructor(dataLoaded: any, dataDb?: any) {
        super(dataLoaded);
        this.dataDb = dataDb || {};
        this.setVersion();
        this.setSheetData();
    }

    public getBerater(): Array<any> {
        return this.objBerater.getData();
    }

    public getBeraterIgnored(): Array<any> {
        return this.objBerater.dataIgnored;
    }

    public getBwl(): Array<any> {
        return this.objBwl.getData();
    }

    public getBwlIgnored(): Array<any> {
        return this.objBwl.dataIgnored;
    }

    public getKraftstoffe(): Array<any> {
        return this.objKraftstoffe.getData();
    }

    public getKraftstoffeIgnored(): Array<any> {
        return this.objKraftstoffe.dataIgnored;
    }

    public getStrom(): Array<any> {
        return this.objStrom.getData();
    }

    public getStromIgnored(): Array<any> {
        return this.objStrom.dataIgnored;
    }

    public getWaerme(): Array<any> {
        return this.objWaerme.getData();
    }

    public getWaermeIgnored(): Array<any> {
        return this.objWaerme.dataIgnored;
    }

    public getWasser(): Array<any> {
        return this.objWasser.getData();
    }

    public getWasserIgnored(): Array<any> {
        return this.objWasser.dataIgnored;
    }

    public hasData(): boolean {
        const objects: any = [this.objBerater, this.objBwl, this.objKraftstoffe, this.objStrom, this.objWaerme, this.objWasser];
        let entries: number = 0;

        objects.forEach((obj: any) => {
            const entities: any = obj.getData() || {};

            Object.keys(entities).forEach((name: any) => {
                entries += entities[name].length;
            });
        });

        return !!entries;
    }

    private isHeaderRow(data: Array<string>): boolean {
        return(
            (data[ImportConstants.COL_AUFNAHME_BEMERKUNG] || null) === 'Bemerkungen'
//            && (data[ImportConstants.COL_AUFNAHME_EINHEIT] || null) === 'Einheit'
        );
    }

    private setSheetData(): void {
        const data: any = this.getSheetDataByName(ImportConstants.SHEET_AUFNAHME);
        let titel: string = null;

        data.forEach((row: Array<string>) => {
            if (!row.length) {
                return;
            }

            if (this.isHeaderRow(row)) {
                titel = row[ImportConstants.COL_AUFNAHME_TITEL] || null;
                this.dataSheet[titel] = [];
            }

            if (titel) {
                this.dataSheet[titel].push(row);
            }
        });
        this.objStrom = new AufnahmebogenStrom(this.dataSheet[ImportConstants.AUFNAHME_STROM] || [], this.dataDb);
        this.objWaerme = new AufnahmebogenWaerme(this.dataSheet[ImportConstants.AUFNAHME_WAERME] || [], this.dataDb);
        this.objWasser = new AufnahmebogenWasser(this.dataSheet[ImportConstants.AUFNAHME_WASSER] || [], this.dataDb);
        this.objKraftstoffe = new AufnahmebogenKraftstoffe(this.dataSheet[ImportConstants.AUFNAHME_KRAFTSTOFFE] || [], this.dataDb);
        this.objBwl = new AufnahmebogenBwl(this.dataSheet[ImportConstants.AUFNAHME_BWL] || [], this.dataDb);
        this.objBerater = new AufnahmebogenBerater(this.dataSheet[ImportConstants.AUFNAHME_BERATER] || [], this.dataDb);
    }

    private setVersion(): void {
        const data: any = this.getSheetDataByName(ImportConstants.SHEET_IMPRESSUM);
        let version: number | string = null;

        data.forEach((row: Array<string>) => {
            row.forEach((value: string) => {
                if (value.includes('Version ')) {
                    const values: Array<string> = value.split(' ');

                    if (values.length > 3) {
                        version = values[3];
                    }
                }
            });
        });
        this.version = version;
    }
}
